import { useEffect } from "react";
function useSelectableCollection(options) {
  const { selectionManager: manager, keyboardDelegate: delegate } = options;
  useEffect(() => {
    if (manager.focusedKey !== null && delegate.getFirstKey() !== null) return;
    const focusedKey = manager.selectedKey || delegate.getFirstKey();
    manager.setFocusedKey(focusedKey);
  }, [manager, delegate]);
  const arrowDown = () => manager.setFocusedKey(delegate.getKeyBelow(manager.focusedKey) ?? delegate.getFirstKey());
  const arrowUp = () => manager.setFocusedKey(delegate.getKeyAbove(manager.focusedKey) ?? delegate.getLastKey());
  const keyMap = {
    ArrowUp: arrowUp,
    ArrowDown: arrowDown
  };
  const onKeyDown = (e) => {
    const action = keyMap[e.key];
    if (e.defaultPrevented || !action) return;
    e.preventDefault();
    action();
  };
  const handlers = { onKeyDown };
  return { collectionProps: handlers };
}
export {
  useSelectableCollection
};
//# sourceMappingURL=useSelectableCollection.es.js.map
